import React, { useState, useEffect } from "react";
import { Card, Button, Tag, Typography, Row, Col, Space, Divider, Avatar, Tabs, Modal, Spin, message } from "antd";
import { DeleteOutlined, ArrowRightOutlined, QuestionCircleOutlined, UserOutlined, EditOutlined, ArrowLeftOutlined, LeftOutlined } from "@ant-design/icons";
import { applicationStatus } from "../../../constants/DataConstants";
import MainLayout from "../../pageHeader/MainLayout";
import { useLocation } from "react-router-dom";
import SidebarLayoutConsumer from "../Administrator/SidebarLayoutConsumer";
import PreviewGeneralInfoForConsumer from "./PreviewGeneralInfoForConsumer";

//import PreviewGeneralInfo from "./PreviewGeneralInfoForConsumer";
import TabPane from "antd/lib/tabs/TabPane";
import ApplicationDetailsTabForConsumer from "./ApplicationDetailsTabForConsumer";
import FinancialStatementTabForConsumer from "./FinancialStatementTabForConsumer";
import ApplicationStatusTabForConsumer from "./ApplicationStatusTabForConsumer";
import AssessmentTabForConsumer from "./AssessmentTabForConsumer";

import ApplicationDetailsTab from "./ApplicationDetailsTabForConsumer";
import FinancialStatementTab from "./FinancialStatementTabForConsumer";
import ApplicationStatusTab from "./ApplicationStatusTabForConsumer";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import _consumerService from "../../../modules/consumerService";
import AssessmentTab from "./AssessmentTabForConsumer";
import { useHistory } from "react-router-dom";
import { routes } from "../../../routes/Routes";
import { COMMON_ERROR_MSG, RECORD_DELETED_MSG } from "../../../constants/constants";
import StatusTag from "../../../components/StatusTag";
import ConsumerDetailApplicationOverview from "./ConsumerDetailApplicationOverview";
import goOnMyApplications from "./GoTOMyapplication";
import GoOnMyApplications from "./GoTOMyapplication";
import DocumentsTab from "./ConsumerDocumentTab";
import ApplicationNotesCard from "./ConsumerNotTab";
import "../../../assets/dist/ConsumerProject/Consumer/ConsumerDashboardNewStyle.css";
const { Text, Title } = Typography;
const { confirm } = Modal;




export default function ConsumerDetailsDashboard() {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const location = useLocation();
  //const isAllStepsCompleted = JSON.parse(localStorage.getItem("isAllStepsCompleted"));


  let data = location.state;
  let applicationObjId = "";
  let applicationId = "";
  let applicationStatusId = null;
  let tabActiveKey = null;
  let emailId = '';

  if (data && data.email) {
    emailId = data.email;
  }

  if (data && data.activeKey) {
    tabActiveKey = data.activeKey;
  }

  if (data && data.applicationData && data.applicationData.Id) {
    applicationObjId = data.applicationData.Id;
  }

  if (data && data.applicationData && data.applicationData.ApplicationId) {
    applicationId = data.applicationData.ApplicationId;
  }

  if (data && data.applicationData && data.applicationData.Application_Status_Id) {
    applicationStatusId = data.applicationData.Application_Status_Id;
  }

  const [applnObjId] = useState(applicationObjId ? applicationObjId : localStorage.getItem("ApplicationObjId"));
  const [applnId] = useState(applicationId ? applicationId : localStorage.getItem("ApplicationIdText"));
  const [applnStatusId] = useState(applicationStatusId ? applicationStatusId : localStorage.getItem("ApplicationStatusId"));
  const [emailID] = useState(emailId ? emailId : localStorage.getItem("ApplicationEmailId"));
  const [applicantInfo, setApplicantInfo] = useState({});


  let activeKeyForTab = tabActiveKey ? tabActiveKey :
    ((localStorage.getItem("fromBalanceSheetScreen") == "false") && localStorage.getItem("fromUserLoginScreen") == "true") ? "1" :
      localStorage.getItem("fromBalanceSheetScreen") == "true" ? "2" : "1";

  const [activeKey, setActiveKey] = useState(activeKeyForTab);

  const previewTabChange = (key) => {
    setActiveKey(key);
  }

  const statusId = applnStatusId ? applnStatusId : localStorage.getItem("ApplicationStatusId");
  const statusNameNew = applicationStatus && applicationStatus.find(status => status.id == Number(statusId))?.name;

  const statusName = applicationStatus && applicationStatus.find(status => status.id == Number(applicantInfo && applicantInfo.Application_Status_Id))?.name;

  // const deleteApplication = () => {
  //   confirm({
  //     title: "Are you sure, want to delete this Application?",
  //     icon: <ExclamationCircleOutlined />,
  //     okText: <span id="yesBtn">Yes</span>,
  //     cancelText: <span id="noBtn">No</span>,
  //     okType: "primary",
  //     onOk() {
  //       deleteApplicationObj();
  //     }
  //   });
  // };

  // const deleteApplicationObj = async () => {
  //   setLoading(true);
  //   try {
  //     const res = await _consumerService.deleteApplicationByAppId(applnObjId ? applnObjId : localStorage.getItem("ApplicationObjId"));
  //     if (res.data.IsSuccess) {
  //       setLoading(false);
  //       message.success(res.data.Message ? res.data.Message : RECORD_DELETED_MSG);
  //       history.push({
  //         pathname: routes.consumerDashboard.path,
  //         state: { email: emailID },
  //       });
  //     } else {
  //       setLoading(false);
  //       message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
  //     }
  //   } catch (e) {
  //     setLoading(false);
  //     console.log(e);
  //   }
  // };

  // const submitApplication = () => {
  //   const statusId = localStorage.getItem("ApplicationStatusId");
  //   const isResubmit = ["4", "5"].includes(statusId);

  //   let titleText = (localStorage.getItem("IsQuestionairCompleted") == "false" || localStorage.getItem("IsQuestionairCompleted") == null)
  //     ? `The Balance Sheet Questionnaire is incomplete. Please review it before submitting. Would you like to review it now?`
  //     : `Are you sure, want to ${isResubmit ? "Resubmit" : "Submit"} this Application?`;

  //   confirm({
  //     title: titleText,
  //     icon: <ExclamationCircleOutlined />,
  //     okText: <span id="yesBtn">Yes</span>,
  //     cancelText: <span id="noBtn">No</span>,
  //     okType: "primary",
  //     onOk() {
  //       if ((localStorage.getItem("IsQuestionairCompleted") == "false" || localStorage.getItem("IsQuestionairCompleted") == null)) {
  //         history.push({
  //           pathname: routes.questionnaireForConsumer.path,
  //           state: { email: emailID, isFromDashboard: false },
  //         });
  //       } else {
  //         history.push({
  //           pathname: routes.applicationSubmitted.path,

  //         });
  //         submitApplicationObj();
  //       }

  //     }
  //   });
  // };

  // const submitApplicationObj = async () => {
  //   if ((localStorage.getItem("IsQuestionairCompleted") == "false" || localStorage.getItem("IsQuestionairCompleted") == null)) {
  //     history.push({
  //       pathname: routes.questionnaireForConsumer.path,
  //       state: { email: emailID, isFromDashboard: false },
  //     });
  //   } else {
  //     setLoading(true);
  //     try {
  //       const appObjId = localStorage.getItem("ApplicationObjId");
  //       const appObjectId = appObjId ? parseInt(appObjId) : null;

  //       const reqObj = {
  //         "Id": appObjectId,
  //         "Application_Status_Id": ["4", "5"].includes(localStorage.getItem("ApplicationStatusId")) ? 6 : 2, // If status is Revision Requested or Action Required, set to Resubmitted (6), else set to Submitted
  //       }
  //       const res = await _consumerService.submitApplicationByAppId(reqObj);
  //       if (res.data.IsSuccess) {
  //         setLoading(false);
  //         message.success(res.data.Message ? res.data.Message : "Application submitted successfully!");
  //         localStorage.setItem("IsSwitchFirmAdmin", JSON.stringify(false));
  //         localStorage.setItem("BankAdminId", res?.data?.Obj?.BankAdminId);
  //         // history.push({
  //         //   pathname: routes.consumerDashboard.path,
  //         //   state: { email: emailID },
  //         // });
  //       } else {
  //         setLoading(false);
  //         message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
  //       }
  //     } catch (e) {
  //       setLoading(false);
  //       console.log(e);
  //     }
  //   }
  // };

  useEffect(() => {
    getApplicantAssesmentInfoByApplicationId(Number(localStorage.getItem("ApplicationObjId")));
  }, [])

  const getApplicantAssesmentInfoByApplicationId = async (applicationObjId) => {
    setLoading(true);
    try {
      const res = await _consumerService.getApplicantAssesmentInfoByApplicationId(Number(applicationObjId));
      if (res.data.IsSuccess) {
        let resObj = res?.data.Obj;
        setApplicantInfo(resObj?.applicantGeneralInfoModel ? resObj.applicantGeneralInfoModel : {});
        localStorage.setItem("ApplicationStatusId", resObj?.applicantGeneralInfoModel ? resObj.applicantGeneralInfoModel.Application_Status_Id : localStorage.getItem("ApplicationStatusId"));
        localStorage.setItem("ApplicantName", resObj?.applicantGeneralInfoModel ? `${resObj.applicantGeneralInfoModel.FirstName || ""} ${resObj.applicantGeneralInfoModel.LastName || ""}`.trim() : "");
        setLoading(false);
      } else {
        message.error(res.data.Message || COMMON_ERROR_MSG);
        setLoading(false);
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const goToMyApplications = () => {
    history.push({ pathname: routes.consumerDashboard.path });
  }
  // console.log(statusId, "statusId onback")
  //  console.log(statusName, "statusName onback ")
  return (
    <Spin spinning={loading}>
      <SidebarLayoutConsumer>

        {/* <Row style={{ marginTop: 16 }}>
          <Col span={24}>
            <Card >
              <GoOnMyApplications />
            </Card>
          </Col>
        </Row> */}
        <Row justify="center" align="middle" className="backtoApplicationsROw"  >
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={24}
            className="applicationbuttons mb10"
          >
            <Space direction="vertical" size={4}>
               <Button
               className="backtoApplicationsButtonDefault"
               type="text"
                icon={<LeftOutlined />}
                onClick={goToMyApplications}
              >
                Back to Applications
              </Button>

              {/* <Title level={5} style={{ margin: 0 }}>
                Application: <Text strong>{applnId ? applnId : localStorage.getItem("ApplicationId")}</Text>
              </Title> */}
              {/* <Text className="f16">
                Application: <Text className="f16" strong>{applnId ? applnId : localStorage.getItem("ApplicationIdText")}</Text>
              </Text> */}
              <Text className="f16">
                {/* Status: <StatusTag statusId={applicantInfo.Application_Status_Id === 5 ? 12 : applicantInfo.Application_Status_Id} /> */}

                {/* <StatusTag statusId={applicantInfo?.Application_Status_Id} /> */}

                {/* <Text  className="f16" strong>{statusName ? statusName : statusNameNew}</Text>                  */}
              </Text>
            </Space>
            <Space style={{ float: "right" }} >

             
              {/* {["1", "6"].includes(localStorage.getItem("ApplicationStatusId")) &&
                <Button
                  type="default"
                  icon={<DeleteOutlined />}
                  onClick={deleteApplication}
                >
                  Delete
                </Button>
              }

              {!["2", "3", "4", "5", "7", "8", "9", "10"].includes(localStorage.getItem("ApplicationStatusId")) &&
                <Button
                  type="default"
                  icon={<ArrowRightOutlined />}
                  onClick={submitApplication}
                >
                  {["6"].includes(localStorage.getItem("ApplicationStatusId")) ? "Resubmit" : "Submit"}
                </Button>
              } */}
            </Space>

          </Col>
        </Row>

        <Row  justify="center">
          {/* <Col
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={24}
          >
            <PreviewGeneralInfoForConsumer
              applnObjId={applnObjId}
              applicantInfo={applicantInfo}
            />
          </Col> */}

          {/* <Col
            xs={24}
            sm={24}
            md={24}
            lg={18}
            xl={18}>
            {applicantInfo?.Application_Status_Id && Number(applicantInfo.Application_Status_Id) === 5 ? (
              <div className="mb15">
                <LatestComments />
              </div>
            ) : null}

            <Tabs
              className="previewTab"
              activeKey={activeKey}
              onChange={previewTabChange}
            >
              {((localStorage.getItem("fromBalanceSheetScreen") == "false") || localStorage.getItem("fromUserLoginScreen") == "true") &&
                < TabPane tab={<span id="setApplicationStatusTab">Application Status</span>} key="1">
                  <div>
                    <ApplicationStatusTabForConsumer activeKey={activeKey} />
                  </div>
                </TabPane>
              }
              < TabPane tab={<span id="setApplicationStatusTab">Application Status</span>} key="1">
                <div>
                  <ApplicationStatusTabForConsumer activeKey={activeKey} />
                </div>
              </TabPane>
              <TabPane tab={<span id="setAssessmentTab">Assessment</span>} key="2">
                <div>
                  <AssessmentTabForConsumer activeKey={activeKey} />
                </div>
              </TabPane>
              <TabPane tab={<span id="setApplicationDetailsTab">Application Details</span>} key="3">
                <div>
                  <ApplicationDetailsTabForConsumer activeKey={activeKey} />
                </div>
              </TabPane>
              <TabPane tab={<span id="setFinancialStatementTab">Financial Statement</span>} key="4">
                <div>
                  <FinancialStatementTabForConsumer activeKey={activeKey} />
                </div>
              </TabPane>
            </Tabs>
          </Col> */}


          <Col xs={24} sm={24} md={24} lg={18} xl={18}>
            <div className="applicationDetailcontainer mb10 mr5">

              {/* --- Header Section (Added) --- */}
              <div className="application-header">
                <div className="header-left">
                  <h1 className="application-title">{applnId ? applnId : localStorage.getItem("ApplicationIdText")}</h1>
                  <p className="application-subtitle">Liquidity Application</p>
                </div>
                <div >
                 <StatusTag className="status-header" statusId={applicantInfo.Application_Status_Id === 5 ? 12 : applicantInfo.Application_Status_Id} />
                </div>
              </div>

              <Tabs
                className="custom-pill-tabs"
                activeKey={activeKey}
                onChange={previewTabChange}
               

              >
                <TabPane tab={<span id="setApplicationStatusTab">Application Status</span>} key="1" />
                <TabPane tab={<span id="setAssessmentTab">Assessment</span>} key="2" />
                <TabPane tab={<span id="setDocumentsTab">Documents</span>} key="3" />
                <TabPane tab={<span id="setNotesTab">Notes</span>} key="5" />
                <TabPane tab={<span id="setFinancialStatementTab">Financial Statement</span>} key="4" />
              </Tabs>

            </div>

            {/* --- Content Section (Rendered Outside Tabs) --- */}

            <div>
              {activeKey === '1' && (
                <ApplicationStatusTabForConsumer activeKey={activeKey} />
              )}

              {activeKey === '2' && (
                <AssessmentTabForConsumer activeKey={activeKey} />
              )}

              {activeKey === '3' && (
                <DocumentsTab activeKey={activeKey} />
              )}

              {activeKey === '5' && (
                <ApplicationNotesCard activeKey={activeKey} />
              )}

              {activeKey === '4' && (
                <FinancialStatementTabForConsumer activeKey={activeKey} />
              )}

            </div>

          </Col>
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={6}
            xl={6}
              className="consumerDetailApplicationOverViewColumn"
            >
            <ConsumerDetailApplicationOverview activeKey={activeKey} />
          </Col>
        </Row>
      </SidebarLayoutConsumer>
    </Spin>
  );
}